import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { PriceListLine } from '../_models/pricelistline';
import { Promotion } from '../_models/promotion';
import { Observable, of, ReplaySubject, throwError } from 'rxjs';
import { catchError, tap, map } from 'rxjs/operators';
import { LicensePlate } from '../_models/licensePlate';
import { ModelSearch } from '../_models/modelSearch';

@Injectable({
  providedIn: 'root'
})
export class PricelistService {
  baseUrl = environment.apiUrl;

  hasPromotion$ = new Observable<boolean>();

  constructor(private http: HttpClient) { }

  getPrices(productcode:string): Observable<PriceListLine[]> {
    
    return this.http.get<PriceListLine[]>(this.baseUrl + 'pricelist/' + productcode)
    .pipe(
      tap(data => {

      }

        //console.log(JSON.stringify(data))
        ),
      catchError(this.handleError)
    );
  }

  getPricesBrand(brand: string, productcode:string): Observable<PriceListLine[]> {
    console.log('getpricesbrand');
    return this.http.get<PriceListLine[]>(this.baseUrl + 'pricelist/'+ brand + '/' + productcode).pipe(
      tap(data => {}

        //console.log(JSON.stringify(data))
        ),
      catchError(this.handleError)
    );
  }

  getPromotions(): Observable<Promotion[]> {
    
    return this.http.get<Promotion[]>(this.baseUrl + 'pricelist/promotions')
    .pipe(
      tap(data => console.log('promotion opgehaald') /*console.log(JSON.stringify(data))*/),

      catchError(this.handleError)
    );
  }

  getLicensePlate(licensePlate: string, artikelgroep: string): Observable<LicensePlate> {
    artikelgroep = encodeURIComponent(artikelgroep.trim()) //"Test%20-%20Text"
    
    return this.http.get<LicensePlate>(this.baseUrl + 'pricelist/LicensePlate/' + licensePlate+ '/' + artikelgroep)
    .pipe(
      tap(data => console.log('license plate opgehaald') /*console.log(JSON.stringify(data))*/),

      catchError(this.handleErrorLicensePlate)
    );
  }

  getLicensePlateGenart(licensePlate: string, genart: number): Observable<LicensePlate> {
   
    return this.http.get<LicensePlate>(this.baseUrl + 'pricelist/LicensePlate/' + licensePlate+ '/genart/' + genart)
    .pipe(
      tap(data => console.log('license plate opgehaald') /*console.log(JSON.stringify(data))*/),

      catchError(this.handleErrorLicensePlate)
    );
  }

  getVin(vin: string, artikelgroep: string): Observable<LicensePlate> {
    artikelgroep = encodeURIComponent(artikelgroep.trim()) //"Test%20-%20Text"
    
    return this.http.get<LicensePlate>(this.baseUrl + 'pricelist/Vin/' + vin+ '/' + artikelgroep)
    .pipe(
      tap(data => console.log('vin opgehaald') /*console.log(JSON.stringify(data))*/),

      catchError(this.handleErrorLicensePlate)
    );
  }

  getVinGenart(vin: string, genart: number): Observable<LicensePlate> {
   
    return this.http.get<LicensePlate>(this.baseUrl + 'pricelist/Vin/' + vin+ '/genart/' + genart)
    .pipe(
      tap(data => console.log('vin opgehaald') /*console.log(JSON.stringify(data))*/),

      catchError(this.handleErrorLicensePlate)
    );
  }

  getKtypeGenart(ktype: number, genart: number): Observable<LicensePlate> {
   
    return this.http.get<LicensePlate>(this.baseUrl + 'pricelist/ktype/' + ktype+ '/genart/' + genart)
    .pipe(
      tap(data => console.log('ktype opgehaald') /*console.log(JSON.stringify(data))*/),

      catchError(this.handleErrorLicensePlate)
    );
  }

  getModelBrands(): Observable<ModelSearch> {
    
    return this.http.get<ModelSearch>(this.baseUrl + 'pricelist/Model/')
    .pipe(
      tap(data => console.log('model brands opgehaald') /*console.log(JSON.stringify(data))*/),

      catchError(this.handleErrorLicensePlate)
    );
  }

  getModelModels(brandId: number): Observable<ModelSearch> {
    
    return this.http.get<ModelSearch>(this.baseUrl + 'pricelist/Model/' + brandId)
    .pipe(
      tap(data => console.log('model models opgehaald') /*console.log(JSON.stringify(data))*/),

      catchError(this.handleErrorLicensePlate)
    );
  }

  getModelTypes(brandId: number, modelId: number): Observable<ModelSearch> {
    
    return this.http.get<ModelSearch>(this.baseUrl + 'pricelist/Model/' + brandId + '/' + modelId)
    .pipe(
      tap(data => console.log('model types opgehaald') /*console.log(JSON.stringify(data))*/),

      catchError(this.handleErrorLicensePlate)
    );
  }

  getModelArticleGroups(brandId: number, modelId: number, typeId: number): Observable<LicensePlate> {
    
    return this.http.get<LicensePlate>(this.baseUrl + 'pricelist/Model/' + brandId + '/' + modelId + '/' + typeId)
    .pipe(
      tap(data => console.log('model articlegroups opgehaald') /*console.log(JSON.stringify(data))*/),

      catchError(this.handleErrorLicensePlate)
    );
  }

  getModelArticleGroup(brandId: number, modelId: number, typeId: number, artikelgroepid: number): Observable<LicensePlate> {
    
    return this.http.get<LicensePlate>(this.baseUrl + 'pricelist/Model/' + brandId + '/' + modelId + '/' + typeId + '/' + artikelgroepid)
    .pipe(
      tap(data => console.log('model articlegroups opgehaald') /*console.log(JSON.stringify(data))*/),

      catchError(this.handleErrorLicensePlate)
    );
  }

  hasPromotions(): Observable<boolean> {
    this.hasPromotion$ = this.http.get<boolean>(this.baseUrl + 'pricelist/HasPromotions')
    .pipe(
      tap(data => console.log('HasPromotions opgehaald: ' + data)) ,
      catchError(this.handleError)
    );
    return this.hasPromotion$;
  }

  private handleError(err: any) {
    // in a real world app, we may send the server to some remote logging infrastructure
    // instead of just logging it to the console
    let errorMessage: string;
    if (err.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      errorMessage = `An error occurred: ${err.error.message}`;
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      errorMessage = `Backend returned code ${err.status}: ${err.body.error}`;
    }
    console.error(err);
    return throwError(errorMessage);
  }

  private handleErrorLicensePlate(err: any) {
    // in a real world app, we may send the server to some remote logging infrastructure
    // instead of just logging it to the console
    let errorMessage: string;

    //console.log(err.error);
    //console.log(err.status);
    
    if (err.status === 404 || err.status === 400)
    {
      //let plate = new Observable<LicensePlate>()
      //plate.autoMerk = err.error;
      return of( err.error);
    }

    if (err.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      errorMessage = `An error occurred: ${err.error.message}`;
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      errorMessage = `Backend returned code ${err.status}: ${err.body.error}`;
    }
    //console.error(err);
    return throwError(errorMessage);
  }
}
